// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function toUpperCase(prim) {
  return prim.toLocaleUpperCase();
}

function toLowerCase(prim) {
  return prim.toLocaleLowerCase();
}

function getStringLetters(param) {
  return Relude_String.splitList("", param);
}

function getFirstLetter(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(getStringLetters, Relude_List.head, param);
              }), (function (param) {
                return Relude_Option.fold("", toUpperCase, param);
              }), param);
}

function upperCaseFirstLetter(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_String.splitList("", param);
                            }), (function (param) {
                              if (param) {
                                return {
                                        hd: param.hd.toLocaleUpperCase(),
                                        tl: param.tl
                                      };
                              } else {
                                return /* [] */0;
                              }
                            }), param);
              }), Relude_String.concatList, param);
}

function isEmpty(param) {
  return Relude_Globals.$great$great(Relude_String.trim, (function (param) {
                return Relude_String.eq("", param);
              }), param);
}

var partial_arg = /\s.*/;

function getFirstWord(param) {
  return param.replace(partial_arg, "");
}

function getLastWord(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_String.splitArray(" ", param);
                            }), Relude_Array.last, param);
              }), (function (param) {
                return Relude_Option.getOrElse("", param);
              }), param);
}

var partial_arg$1 = /\D+/g;

function getNumbersOnly(param) {
  return Relude_String.replaceRegex(partial_arg$1, "", param);
}

var partial_arg$2 = /^[0-9]*(\.?[0-9]{0,2})?$/;

var partial_arg$3 = Relude_Option.keep(function (param) {
      return partial_arg$2.test(param);
    });

function getValidCurrencyUSD(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg$3, param);
}

function leftPad(padWith, minLength, str) {
  return Relude_String.makeWithIndex(minLength - Relude_String.length(str) | 0, (function (param) {
                return Relude_Globals.$$const(padWith, param);
              })) + str;
}

var partial_arg$4 = /^\+?1+/;

function removeUSAPhonePrefix(param) {
  return Relude_String.replaceRegex(partial_arg$4, "", param);
}

var partial_arg$5 = /^[0-9]*$/;

function isOnlyNumbers(param) {
  return partial_arg$5.test(param);
}

function fullNameToFirstAndLast(name) {
  var match = Relude_String.splitList(" ", name);
  if (match) {
    return [
            match.hd,
            Relude_List.foldLeft((function (prim, prim$1) {
                      return prim + prim$1;
                    }), "")(Relude_List.intersperse(" ", match.tl))
          ];
  } else {
    return [
            name,
            ""
          ];
  }
}

var interpunct = " · ";

exports.toUpperCase = toUpperCase;
exports.toLowerCase = toLowerCase;
exports.getStringLetters = getStringLetters;
exports.getFirstLetter = getFirstLetter;
exports.upperCaseFirstLetter = upperCaseFirstLetter;
exports.isEmpty = isEmpty;
exports.getFirstWord = getFirstWord;
exports.getLastWord = getLastWord;
exports.getNumbersOnly = getNumbersOnly;
exports.getValidCurrencyUSD = getValidCurrencyUSD;
exports.leftPad = leftPad;
exports.interpunct = interpunct;
exports.removeUSAPhonePrefix = removeUSAPhonePrefix;
exports.isOnlyNumbers = isOnlyNumbers;
exports.fullNameToFirstAndLast = fullNameToFirstAndLast;
/* partial_arg Not a pure module */
